export default function KpiCard({ label, value, sub, tone = "default", testId }) {
  const tones = {
    default: "text-slate-900",
    warning: "text-amber-600",
    error: "text-red-600",
  };
  return (
    <div className="bg-white rounded-lg border border-slate-200 px-4 py-3" data-testid={testId}>
      <div className="text-[11px] uppercase tracking-wide text-slate-500 font-medium">{label}</div>
      <div className={`text-3xl font-semibold font-heading mt-0.5 ${tones[tone] || tones.default}`} data-testid={`${testId}-value`}>{value}</div>
      {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}
